module.exports = __webpack_public_path__ + "static/media/Reitti.488864f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Reitti.png
// module id = 1435
// module chunks = 0